/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'
/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  placements: {
    '& .sectiongroupv2 > .header': {
      width: '100%'
    },
    '& .configtoggle': {
      '& > .content': {
        borderLeft: 'none',
        paddingLeft: '48px'
      }
    },
    '& .disabled': {
      pointerEvents: 'none',
      opacity: 0.3
    },
    '& .previewconfig': {
      maxWidth: '500px',
      '&.showfirstslot-true': {
        '& .container': {
          gridTemplateColumns: 'repeat(3, 1fr) !important'
        },
        '&.desktop': {
          '& .rightarrow': {
            left: pxToEm(-30)
          },
          '&.enablespotlight-true': {
            '& .rightarrow': {
              left: pxToEm(-24)
            },
          }
        },
        '&.mobile': {
          '& .container': {
            gridTemplateColumns: 'repeat(2, 1fr) !important'
          }
        }
      },
      '&.showfirstslot-false': {
        '& .container': {
          gridTemplateColumns: 'repeat(3, 1fr) !important'
        },
        '& .rightarrow': {
          left: pxToEm(-20)
        },
        '&.mobile': {
          '& .container': {
            gridTemplateColumns: 'repeat(2, 1fr) !important'
          }
        }
      },
      '& .content': {
        '& .arrowwrap': {
          position: 'relative',
          width: 0,
          top: pxToEm(-10)
        },
        '& .rightarrow': {
          left: pxToEm(-20)
        },
        '& .leftarrow': {
          left: pxToEm(-8)
        },
        '& .articlecard': {
          width: '100%',
          minWidth: 'auto',
          '&.horizontal': {
            minHeight: '125px'
          }
        },
        '& .firstslot': {
          width: '100%',
          maxWidth: pxToEm(360),
          alignItems: 'center'
        },
        '& .container': {
          maxWidth: pxToEm(360),
          display: 'grid',
          gridGap: pxToEm(8),
          '& .articlecard': {
            height: '125px'
          }
        },
        '& .loadmore': {
          display: 'flex',
          width: pxToEm(180),
          height: pxToEm(36),
          padding: `${pxToEm(16)} 0`,
          justifyContent: 'center',
          alignItems: 'center',
          background: '#000',
          color: '#FFF',
          borderRadius: pxToEm(30),
          fontSize: pxToEm(14)
        },
        '& .afterrowcard': {
          padding: `0 ${pxToEm(8)}`,
          '& .articlecard': {
            height: '120px',
            width: 'auto'
          }
        },
        '& h3': {
          fontFamily: '"Source Serif Pro", Georgia, serif',
          paddingBottom: pxToEm(8),
          borderBottom: '3px solid #000'
        },
        '& svg': {
          position: 'relative'
        }
      },
      '&.mobile': { 
        maxWidth: '250px',
        '& .firstslot': {
          maxWidth: `${pxToEm(240)} !important`
        }
      },
      '& .loadmorebutton': {
        background: '#000', 
        color: '#FFF', 
        borderRadius: '30px', 
        height: '40px', 
        width: '220px', 
        fontWeight: 600,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '& .insticator-logo': {
        width: '200px',
        height: '20px'
      },
      '& .divider': { background: '#000', height: '2px', width: '100%' },
      '& h3': {
        fontFamily: '"Source Serif Pro",serif',
        maxWidth: pxToEm(400),
        width: '100%'
      }
    }
  }
});
